import React from 'react';
import { Link } from 'react-router';

import { LazyImage } from 'components/common/Image';
import { constructMSAImageUrl } from 'helpers';

const RELATED_STYLE_IMG_SRC_PARAMS = { autoCrop: true, height: 100 };

const SwatchImage = ({ imageId, thumbnailImageId, msaImageId, styleColor, productSeoUrl, styleId, setImageId }) => {
  const msaId = imageId || thumbnailImageId || msaImageId || null;
  const imgSrc = constructMSAImageUrl(msaId, RELATED_STYLE_IMG_SRC_PARAMS);
  let linkEvents = null;

  if (setImageId) {
    linkEvents = {
      onMouseEnter: () => setImageId(msaId),
      onMouseLeave: () => setImageId(null),
      onFocus: () => setImageId(msaId),
      onBlur: () => setImageId(null)
    };
  }

  return (
    <li key={styleId}>
      <Link
        to={productSeoUrl}
        {...linkEvents}>
        <LazyImage src={imgSrc} alt={`Color ${styleColor}`} />
      </Link>
    </li>
  );
};

export default SwatchImage;
